import { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { QuestionOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import * as S from './AuthLayout.styles';
import IconLogo from '~/assets/images/geocloud_logo.png';
import SwitcherLng from '~/components/common/SwitcherLng';
import Routes from '~/routes/routes';

function AuthLayout({ children }: { children: ReactElement }) {
  const { t } = useTranslation();

  return (
    <S.Wrapper>
      <S.Language>
        <SwitcherLng theme="dark" />
      </S.Language>

      {/* Left Panel - Logo & Info */}
      <S.LeftPanel>
        <S.LeftPanelContent>
          <S.LeftPanelLogo src={IconLogo} alt="GeoCloud" />
          <S.LeftPanelTitle>{t('common_appname') || 'GeoCloud'}</S.LeftPanelTitle>
          <S.LeftPanelDescription>{t('common_app_description') || 'Cloud Native GIS'}</S.LeftPanelDescription>
        </S.LeftPanelContent>
      </S.LeftPanel>

      {/* Right Panel - Form */}
      <S.RightPanel>
        <S.MobileHeader>
          <S.MobileLogo src={IconLogo} alt="GeoCloud" />
          <S.MobileTitle>{t('common_appname') || 'GeoCloud'}</S.MobileTitle>
          <S.MobileDescription>{t('common_app_description') || 'Cloud Native GIS'}</S.MobileDescription>
        </S.MobileHeader>

        <S.Content>
          <S.Children>{children}</S.Children>

          <S.Support>
            <Link to={Routes.HOME}>{t('homepage') || 'Trang chủ'}</Link>
          </S.Support>
        </S.Content>
      </S.RightPanel>

      <S.Question>
        <QuestionOutlined />
      </S.Question>
    </S.Wrapper>
  );
}

export default AuthLayout;
